import React from "react";

const AccountDetails = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold">Account Details</h1>
    </div>
  );
};

export default AccountDetails;
